var React = require('react');

function AddressInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M9.83366 6.66671C9.83366 7.67923 9.01285 8.50004 8.00033 8.50004C6.9878 8.50004 6.16699 7.67923 6.16699 6.66671C6.16699 5.65419 6.9878 4.83337 8.00033 4.83337C9.01285 4.83337 9.83366 5.65419 9.83366 6.66671Z","stroke":"black","strokeWidth":"1.5","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M12.8337 6.66671C12.8337 9.45151 10.5488 11.9974 9.12102 13.3164C8.47972 13.9089 7.52093 13.9089 6.87963 13.3164C5.45183 11.9974 3.16699 9.45151 3.16699 6.66671C3.16699 3.99733 5.33095 1.83337 8.00033 1.83337C10.6697 1.83337 12.8337 3.99733 12.8337 6.66671Z","stroke":"black","strokeWidth":"1.5","strokeLinejoin":"round","key":1})]);
}

AddressInline.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = AddressInline;

AddressInline.default = AddressInline;
